export let collaborationRoles = {};

collaborationRoles[(collaborationRoles['owner'] = 1)] = 'owner';
collaborationRoles[(collaborationRoles['admin'] = 2)] = 'admin';
collaborationRoles[(collaborationRoles['editor'] = 3)] = 'viewer';
collaborationRoles[(collaborationRoles['viewer'] = 4)] = 'viewer';
